export const prix = [
  { label: "1 000 DT", value: 1000 },
  { label: "2 000 DT", value: 2000 },
  { label: "3 000 DT", value: 3000 },
  { label: "4 000 DT", value: 4000 },
  { label: "5 000 DT", value: 5000 },
  { label: "6 000 DT", value: 6000 },
  { label: "7 000 DT", value: 7000 },
  { label: "8 000 DT", value: 8000 },
  { label: "9 000 DT", value: 9000 },
  { label: "10 000 DT", value: 10000 },
  { label: "12 500 DT", value: 12500 },
  { label: "15 000 DT", value: 15000 },
  { label: "17 500 DT", value: 17500 },
  { label: "20 000 DT", value: 20000 },
  { label: "25 000 DT", value: 25000 },
  { label: "30 000 DT", value: 30000 },
  { label: "40 000 DT", value: 40000 },
  { label: "50 000 DT", value: 50000 },
  { label: "60 000 DT", value: 60000 },
  { label: "70 000 DT", value: 70000 },
  { label: "80 000 DT", value: 80000 },
  { label: "90 000 DT", value: 90000 },
  { label: "100 000 DT", value: 100000 },
  { label: "125 000 DT", value: 125000 },
  { label: "150 000 DT", value: 150000 },
  { label: "175 000 DT", value: 175000 },
  { label: "200 000 DT", value: 200000 },
];
export const distance = [
  
  { label: "10 000 Km", value: 10000 },
  { label: "20 000 Km", value: 20000 },
  { label: "30 000 Km", value: 30000 },
  { label: "40 000 Km", value: 40000 },
  { label: "50 000 Km", value: 50000 },
  { label: "60 000 Km", value: 60000 },
  { label: "70 000 Km", value: 70000 },
  { label: "80 000 Km", value: 80000 },
  { label: "90 000 Km", value: 90000 },
  { label: "100 000 Km", value: 100000 },
  { label: "125 000 Km", value: 125000 },
  { label: "150 000 Km", value: 150000 },
  { label: "175 000 Km", value: 175000 },
  { label: "200 000 Km", value: 200000 },
];
